<template>
  <el-container class="login-box">
    <el-main>
        <el-row class="content" type="flex" :gutter="10">
            <el-col :span="12">
                <div class="content-left"></div>
            </el-col>
            <el-col :span="12">
                <div class="content-right">
                    <div class="content-right-header"> 
                        <img src="@/assets/login/login-title.png" alt="">
                        <img src="@/assets/login/login-title1.png" alt="">
                    </div>
                    <sign v-if="!isRegister" @changeSign="isRegister=true"/>
                    <register v-else @changeRegister="isRegister=false"/>
                </div>
            </el-col>
        </el-row>
    </el-main>
    <el-footer> 浙江小诗科技有限公司 Copyright & #169 2020-2021 浙ICP备</el-footer>
  </el-container>
</template>

<script>
import sign from '@/view/login/sign'
import register from '@/view/login/register'

export default {
    components:{
        sign,
        register
    },
    data() {
        return {
            isRegister:false
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
*:focus {
    outline: none
}
.login-box{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: linear-gradient(135deg,#93e4d9, #5ac5b1);
    .el-main{
        padding: 0 450px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .content{
            width: 100%;
            min-width: 850px;
            height: 672px;
            border-radius: 20px;
            box-shadow: 0px 0.16px 0.29px 0.24px rgba(164,200,195,0.40);
            background-color: #c4ede7;
            .el-col{
                padding: 0 !important;
            }
            &-left{
                width: 100%;
                height: 100%;
                margin-left: -25px;
                background: url('~@/assets/login/login-bg.png') center no-repeat;
                background-size: contain;
            }
            &-right{
                height: 100%;
                border-radius: 0 20px 20px 0;
                padding: 63px 60px;
                box-sizing: border-box;
                background-color: #ffffff;
                &-header{
                    display: flex;
                    align-items: flex-end;
                    margin-bottom: 33px;
                    img:first-child{
                        width: 149px;
                        height: auto;
                    }
                    img:last-child{
                        width: 170px;
                        height: auto;
                    }
                }
            }
        }
    }
    .el-footer{
        color: #ffffff;
        text-align: center;
        line-height: 60px;
    }
}
</style>